export const ADVISOR_MANUAL = 'ADVISOR_MANUAL';
export const ADVISOR_INTEGRATION = 'ADVISOR_INTEGRATION';
export const ADVISOR_BATCH = 'ADVISOR_BATCH';
export const REFERRAL_PARTNER = 'REFERRAL_PARTNER';
export const SELF = 'SELF';
export const UNKNOWN = 'UNKNOWN';
